// Runs the callback whenever the user comes back to the tab, e.g. after the
// system has slept. Returns a function that stops it.
export const onTabReturn = (callback: () => void) => {
  const runWhenVisible = () => {
    if (document.visibilityState === 'visible') callback()
  }

  window.addEventListener('focus', callback)
  document.addEventListener('visibilitychange', runWhenVisible)

  return () => {
    window.removeEventListener('focus', callback)
    document.removeEventListener('visibilitychange', runWhenVisible)
  }
}
